import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScreenService {
  private observer = inject(BreakpointObserver);

  // Señales reactivas
  isMobile = signal(false);
  width = signal(window.innerWidth);

  constructor() {
    // Observa breakpoint de Handset (móviles)
    this.observer.observe(['(max-width: 510px)']).subscribe((result) => {
      this.isMobile.set(result.matches);
    });

    // También escucha resize nativo
    window.addEventListener('resize', () => {
      this.width.set(window.innerWidth);
    });
  }

  /**
   * Valida si la pantalla cumple con un ancho máximo
   */
  isMaxWidth(max: number): boolean {
    return this.width() <= max;
  }

  /**
   * Valida si la pantalla cumple con un ancho mínimo
   */
  isMinWidth(min: number): boolean {
    return this.width() >= min;
  }
}
